module.exports = __webpack_public_path__ + "img/dinner_title--success.b7b9f0cd.png";